import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import config from 'constants/config'

type UndoDeleteItemsRequest = paths['/api/carts/multi-carts/{multiCartId}/undo-delete-items']['post']['parameters']['body']['payload']
type UndoDeleteItemsResponse = paths['/api/carts/multi-carts/{multiCartId}/undo-delete-items']['post']['responses']['204']['content']['application/json']

export async function undoDeleteItemsFromMultiCart(
  multiCartId: string,
  itemIds: Array<string>,
): Promise<{ success: boolean }> {
  if (itemIds.length === 0) {
    return Promise.resolve({ success: true })
  }

  const payload: UndoDeleteItemsRequest = {
    itemIds,
  }

  await request.post<UndoDeleteItemsResponse, UndoDeleteItemsRequest>(
    `/api/carts/multi-carts/${multiCartId}/undo-delete-items?brand=${config.BRAND}`,
    payload,
    { credentials: 'include' },
  )

  return { success: true }
}
